import {useSelector} from "react-redux";
import {Stack, Typography, useTheme, Divider, InputAdornment, Button, Box} from '@mui/material'
import SelectNetwork from '@/pages/components/SelectNetwork'
import AppModal from "@/components/AppModal";
import {decimalDivide, decimalMinus, toDecimalAndFixed, toDesimalPlaces} from "@/utils/decimal";
import {useTranslation} from "react-i18next";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import { useUserVariteies, useWithdrawInit } from '@/pages/hooks'
import {getRegExpByPrecision, getUrlParams} from "@/utils/utils";
import { clearTaskRule, setTaskRuleParams } from '@/redux/slices/user';
import { withdrawApply } from '@/services/user'

import AppTextField from "@/components/AppTextField";
import RpIcon from "@/components/RpIcon";

import RouteConstant from "@/constant/RouteConstant";
import {createSearchParams, useNavigate, useSearchParams} from "react-router-dom";

import {useFormik} from "formik";
import {isAddress} from "viem";
import AppLoadingButton from "@/components/mui/LoadingButton";
import TwoFAModal from "@/components/TwoFAModal";
import {useBoolean, useRequest, usePrevious} from "ahooks";
import {VerifyAction} from "@/constant/VerifyConstant";

import mobileClasses from "./mobile.module.css";
// import PageBack from "@/components/PageBack";

import {dispatch} from "@/redux/store";
import { setWithdrawInfo } from "@/redux/slices/assets";
import SimpleHeader from "@/pages/components/Headers/SimpleHeader.tsx";
// import {useKeepAliveContext} from "@hhhgamehhh/keepalive-for-react";

const WithdrawPage = () => {
  const paramVarietyCode = getUrlParams("variety_code");
  const theme = useTheme()
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [selectetNetwork, setSelectedNetwork] = useState(null);
  const [isKeyboardShow, setIsKeyboardShow] = useState(false);
  // const previousSelectedNetwork = usePrevious(selectetNetwork);
  // const [coin, setCoin] = useState('');
  const [varietyCode, setVarietyCode] = useState(paramVarietyCode);
  const [addressInfo, setAddressInfo] = useState(null);
  const [twoFAModalShow , twoFAModalShowOperate] = useBoolean(false);

  const { withdrawInfo } = useSelector((state) => state.assets);

  const {user, isAuthenticated, homeInfo} = useSelector((state) => state.user);
  const [confirmModalShow, confirmModalShowOperate] = useBoolean(false)

  const getWithdrawInitInfoReq = useWithdrawInit()

  // const { refresh, destroy } = useKeepAliveContext();
  const [searchParams, setSearchParams] = useSearchParams();
  const withdrawApplyReq = useRequest(async () => {
    const postData = {
      varietyCode: paramVarietyCode,
      'coin': selectetNetwork.coin,
      'withdrawAddress': formObj.values.address,
      'amount': formObj.values.amount,
    }
    const res = await withdrawApply(postData)
    return res
  }, { manual: true })

  const withdrawVariety = useMemo(() => {
    if (!homeInfo) {
      return null
    }
    const _ret = homeInfo.assetUser.accountList.find(_ => {
      return _.varietyCode == varietyCode
    })
    return _ret
  }, [varietyCode, homeInfo])

  const precision = useMemo(() => {
    if (!getWithdrawInitInfoReq?.data) {
      return 2
    }
    return getWithdrawInitInfoReq?.data?.withdrawPrecision
  }, [])

  useEffect(() => {
    if (withdrawInfo.network && getWithdrawInitInfoReq?.data) {
      const _selectedNetwork = getWithdrawInitInfoReq?.data.coinList.find(_ => _.coin == withdrawInfo.network.coin)
      setSelectedNetwork(_selectedNetwork)
    }
  }, [withdrawInfo, getWithdrawInitInfoReq?.data])

  useEffect(() => {
    if (withdrawInfo?.address) {
      formObj.setFieldValue('address', withdrawInfo.address)
    }
  }, [withdrawInfo?.address])

  useEffect(() => {
    getWithdrawInitInfoReq.runAsync(paramVarietyCode)
    let initialHeight = window.innerHeight;
    window.addEventListener('resize', handleResize);
    function handleResize() {
      const currentHeight = window.innerHeight;
      console.log("currentHeight",currentHeight)
      if (currentHeight < initialHeight) {
        // console.log('键盘弹出');
        setIsKeyboardShow(true)
      } else {
        setIsKeyboardShow(false)
        // console.log('键盘收起');
      }
    }
  }, []);

  useEffect(() => {
    if (selectetNetwork) {
      // setCoin(selectetNetwork.coin)
      setAddressInfo(null)
    }
  }, [selectetNetwork]);

  const doWithdraw = () => {
    clearTaskRule()
    setTaskRuleParams(({
      action: VerifyAction.WITHDRAW_APPLY,
      expand: {
        "withdrawExpand": {
          'variety': paramVarietyCode,
          'amount': formObj.values.amount,
          'coin': selectetNetwork.coin,
          'withdrawAddress': formObj.values.address,
        }
      }
    }))
    twoFAModalShowOperate.setTrue()
  }

  const doWithdrawApply = () => {
    twoFAModalShowOperate.setFalse()
    withdrawApplyReq.runAsync().then(res => {
      confirmModalShowOperate.setFalse()
      // navigate(`${RouteConstant.USER_WITHDRAW_SUCCESS}?sn=${res}`)
      navigate({
        pathname: RouteConstant.USER_WITHDRAW_SUCCESS,
        search: createSearchParams({
          ...Object.fromEntries(searchParams),
          sn: res,
        }).toString(),
      });
    })
  }

  const formObj = useFormik({
    initialValues: {
      address: '',
      amount: ''
    },
    enableReinitialize: true,
    // validationSchema,
    validate: values => {
      const errors = {};

      if (!values.address) {
        errors.address = t('this_field_is_required');
      }
      // if (!isAddress(values.address)) {
      //   errors.address = 'Invalid address';
      // }
      if (!values.amount) {
        errors.amount = t('this_field_is_required');
      }
      if (parseFloat(values.amount) < parseFloat(selectetNetwork?.withdrawMin)) {
        errors.amount = t('withdraw_lower_than_min')
      }
      if (parseFloat(values.amount) > parseFloat(withdrawVariety?.available)) {
        errors.amount = t('withdraw_amount_larger_than_available');
      }
      return errors;
    },
    validateOnBlur: true,
    validateOnChange: true,
    validateOnMount: true,
    onSubmit: (values) => {
      confirmModalShowOperate.setTrue()
      // doWithdraw()
    },
  })

  const setAmountAll = () => {
    formObj.setFieldValue('amount', withdrawVariety?.available)
  }

  const onAmountChange = (e) => {
    const val = e.target.value;
    let filteredInput = val.replace(/[^\d.]/g, "")
      .replace(/^\./g, "")
      .replace(/^0\d[0-9]*/g, "0");

    const reg = getRegExpByPrecision(8);

    if (filteredInput === "" || reg.test(filteredInput)) {
      // if (Number(filteredInput) !== 0) {
      //   filteredInput = _validateAmount(filteredInput);
      // }
      let _va =  toDesimalPlaces(filteredInput, 2).toString()
      formObj.setFieldValue('amount', filteredInput)
    }
  }

  const receivedAmount = useMemo(() => {
    if (!formObj.values.amount) {
      return 0
    }
    if (parseFloat(formObj.values.amount) < parseFloat(selectetNetwork?.withdrawMin)) {
      return 0
    }
    if (parseFloat(formObj.values.amount) > parseFloat(withdrawVariety?.available)) {
      return 0
    }
    if (formObj.values.amount > 0) {
      return decimalMinus(formObj.values.amount, (selectetNetwork?.withdrawFee || 0))
    }

    return 0
  }, [selectetNetwork, formObj.values.amount])
  const handleSelectNetwork= useCallback((network)=>{
    // console.log("选中的network",network)
    setSelectedNetwork(network)
  },[])

  return (<>

      <Stack
        className={mobileClasses.root}>
        <SimpleHeader
          closeButton={
          <RpIcon icon={'arrow-left'} size={22} clickable
          onClick={() => {
            // destroy()
            // dispatch(setWithdrawInfo({
            //   address: '',
            //   amount: '',
            //   network: null,
            // }))
            // formObj.setFieldValue('address', '')
            // formObj.setFieldValue('address', '')
            navigate(-1)
          }}
          />}
          action={
            <Box onClick={() => {
              // navigate(`${RouteConstant.WITHDRAW_LIST}`);
              navigate({
                pathname: RouteConstant.WITHDRAW_LIST,
                search: window.location.search,
                replace: true
              });
            }}>
              <RpIcon icon={'file'} size={22}/>
            </Box>
          }
        />
        <Stack
          sx={{padding: '0 16px 16px 16px'}}
        >
          <form autoComplete="off" onSubmit={formObj.handleSubmit}>
            <Typography fontSize={'28px'} fontWeight={'700'}>
              {t('withdraw')} {withdrawVariety ? withdrawVariety.shortName : ''}
            </Typography>
            <Stack
              direction="column" justifyContent="center"
              className={mobileClasses.varieties}
            >
              <Stack
                sx={{marginBottom: '24px'}}
              >
                <Box sx={{fontSize:'13px',fontWeight:'400',marginBottom:'6px'}}>{t('network')}</Box>
                <SelectNetwork
                  selectedNetwork={selectetNetwork}
                  variety={withdrawVariety}
                  paramWithdrawInfo={getWithdrawInitInfoReq?.data}
                  onSelected={handleSelectNetwork}
                  onChange={() => {
                    formObj.setFieldValue('address', '')
                    formObj.setFieldValue('amount', '')
                  }}
                />
              </Stack>
              <Stack>
                <AppTextField
                  label={t('address')}
                  disabled={!selectetNetwork}
                  name="address"
                  value={formObj.values.address}
                  error={Boolean(formObj.touched.address && formObj.errors.address)}
                  helperText={formObj.touched.address && formObj.errors.address}
                  autoComplete="off"
                  placeholder={t('address')}
                  onChange={(e) => formObj.setFieldValue('address', e.target.value.trim())}
                  fullWidth
                  sx={{mb: '22px'}}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {formObj.values.address &&
                          <RpIcon color={theme.palette.text.primary} icon="close" size={15} onClick={
                            () => {
                              formObj.setFieldValue('address', '')
                            }
                          } clickable/>}
                        <RpIcon icon={'book'}
                          clickable={selectetNetwork}
                          onClick={() => {
                            if (!selectetNetwork) {
                              return
                            }
                            dispatch(setWithdrawInfo({
                              ...withdrawInfo,
                              address: formObj.values.address,
                              amount: formObj.values.amount,
                              network: selectetNetwork,
                            }))
                            navigate({
                              pathname: RouteConstant.USER_ADDRESS_LIST,
                              search: createSearchParams({
                                ...Object.fromEntries(searchParams),
                                variety_code: paramVarietyCode,
                                coin: selectetNetwork.coin,
                                display_name: selectetNetwork.displayName,
                              }).toString()
                            });

                          }}
                        ></RpIcon>
                      </InputAdornment>
                    ),
                  }}
                />

              </Stack>
              <Stack>
                <AppTextField
                  label={t('amount')}
                  disabled={!selectetNetwork}
                  name="amount"
                  placeholder={`Minimum ${selectetNetwork?.withdrawMin}`}
                  value={formObj.values.amount}
                  error={Boolean(formObj.touched.amount && formObj.errors.amount)}
                  helperText={formObj.touched.amount && formObj.errors.amount}
                  autoComplete="off"
                  fullWidth
                  onChange={onAmountChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="start">
                        {formObj.values.amount &&
                          <RpIcon color={theme.palette.text.primary} icon="close" size={15} onClick={
                            () => {
                              formObj.setFieldValue('amount', '')
                            }
                          } clickable/>}
                        <Typography color="textPrimary" fontSize={'16px'}>{paramVarietyCode?.toUpperCase()}</Typography>
                        <Button
                          disabled={!selectetNetwork}
                          sx={(theme) => {
                          return {
                            color: theme.palette.brand.main,
                            minWidth:"auto",
                            paddingRight:'0',
                            fontSize: '16px',
                          }
                        }}
                                onClick={() => {
                                  setAmountAll()
                                }}
                        >{t('all')}</Button>
                      </InputAdornment>
                    ),
                  }}
                />
                <Typography fontSize={'12px'} sx={{marginTop: '15px'}}>
                  <span className={'small'}>{t('available')}</span> {withdrawVariety?.available} {varietyCode.toUpperCase()}</Typography>
              </Stack>
            </Stack>
            <Stack
              sx={{height: '50px', position: 'absolute', bottom: '16px', left: 0, width: '100%', padding: '0 16px',visibility:isKeyboardShow?"hidden":"visible"}}
            >
              <Stack direction="row" alignItems="center">
                <Stack sx={{flex: 1}} gap={'4px'}>
                  <Typography fontSize={'10px'} color={'textSecondary'}>{t('received_amount')}</Typography>
                  <Typography fontSize={'16px'} fontWeight={500} color="error">{receivedAmount} {varietyCode.toUpperCase()}</Typography>
                  <Typography fontSize={'10px'} color={'textSecondary'}>{t('fee')} {selectetNetwork?.withdrawFee} {varietyCode.toUpperCase()}</Typography>
                </Stack>
                <AppLoadingButton
                  disabled={!selectetNetwork || !receivedAmount}
                  sx={{flex: 1, height: '50px',}} variant="contained"
                  type="submit">{t('withdraw')}</AppLoadingButton>
              </Stack>
            </Stack>
          </form>
        </Stack>

      </Stack>

      <TwoFAModal successCallback={doWithdrawApply} open={twoFAModalShow} onClose={twoFAModalShowOperate.setFalse}/>
      <AppModal
      open={confirmModalShow}
      onClose={confirmModalShowOperate.setFalse}
      >
        <Stack >
          <SimpleHeader backEnable title={t('review_details')}
                        closeButton={<RpIcon icon="close"
                        clickable
                        onClick={() => {
                          confirmModalShowOperate.setFalse()
                        }}
                        />}
          />
          <Stack
            sx={{padding: '16px'}}
            direction="row" alignItems="center" justifyContent="space-between">
            <Stack>
              <Typography>{t('you_will_withdraw')}</Typography>
              <Box component="div">
                {/*{toDesimalPlaces(formObj.values.amount, 8)}*/}
                <span className={'h1'}>{formObj.values.amount}</span>
                <span className={'h3'}> {varietyCode.toUpperCase()}</span>
              </Box>
            </Stack>
            <img src={`/images/card/pay-review.svg`} width={'72'}/>
          </Stack>
          <Divider />
          <Stack sx={{padding: '16px'}} gap={'12px'}>
            <Typography>{t('withdraw_info')}</Typography>
            <Stack direction="row" justifyContent="space-between">
              <p className={'label'}>{t('network')}</p>
              <Typography>{selectetNetwork?.displayName}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between" gap={'20px'}>
              <p style={{whiteSpace: 'nowrap'}} className={'label'}>{t('address')}</p>
              <Typography className={'text-break'}>{formObj.values.address}</Typography>
            </Stack>
            <Stack direction="row" justifyContent="space-between">
              <p className={'label'}>{t('fee')}</p>
              <Typography>{selectetNetwork?.withdrawFee} {varietyCode.toUpperCase()}</Typography>
            </Stack>
            <Stack direction="row" className={'alert-warm-info'} gap={'6px'}>
              <RpIcon icon={'info'} size={22}/>
              <Typography sx={theme => {return {fontSize: theme.typography.pxToRem(12)};}}>
                {t("please_confirm_same_network")}
              </Typography>
            </Stack>
            <AppLoadingButton
              sx={{marginTop: '16px'}}
              size={'large'}
              loading={withdrawApplyReq.loading}
              onClick={() => { doWithdraw() }} fullWidth variant="contained"
            >
              {t('confirm')}
            </AppLoadingButton>
          </Stack>
        </Stack>
      </AppModal>
    </>
  )
}

export default React.memo(WithdrawPage);
